<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>내 처방 상세 정보</h2>
      </div>

      <article class="view">
        <div class="table_list">
          <h3 class="tb_title">내 처방 정보</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>처방명</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="myPrescibeInfo.prescribe_nm"
                  />
                </td>
              </tr>
              <tr>
                <th>출전</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="myPrescibeInfo.prescribe_source"
                  />
                </td>
              </tr>
              <tr>
                <th>카테고리</th>
                <td>
                  <div class="form_select">
                  <b-form-select v-model="myPrescibeInfo.prescribe_category" >
                    <b-form-select-option value="">선택</b-form-select-option>
                    <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                  </b-form-select>
                </div>
                </td>
              </tr>
              <tr>
                <th>메모</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="myPrescibeInfo.prescribe_note"
                  />
                </td>
              </tr>
              <tr>
                <th>등록일자</th>
                <td>
                  <span>{{formatDate_YYYYMMDD(myPrescibeInfo.prescribe_dt)}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table_list">
          <div class="table_option">
            <div class="form_select">
              <h3 class="tb_title">내 처방 약재</h3>
            </div>
            <button class="btn btn_md btn_blue" v-b-modal.medicineSearch>추가</button>
          </div>

          <table class="write">
            <colgroup>
              <col width="34%" />
              <col width="10%" />
              <col width="45%" />
              <col width="10%" />
              <col width="50" />
            </colgroup>
            <thead>
              <th class="ac">약재명</th>
              <th class="ac">이명</th>
              <th class="ac">설명</th>
              <th class="ac">첩량</th>
              <th class="ac">삭제</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in medicineList" :key="index">
                <td class="ac"><span>{{ item.med_hrb_nm }}</span></td>
                <td class="ac"><span>{{ item.med_alias }}</span></td>
                <td><span>{{ item.med_prfm  }}</span></td>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="item.medicine_use_qnty"
                  />
                </td>
                <td>
                  <button class="icon icon_del" @click="fn_medList_delete(index)"></button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="bottom_box">
            <button class="btn btn_md btn_darkbrown" @click="fn_move_list_page">
              목록
            </button> 
            <div class="btn_box">
                <button class="btn btn_md btn_brown" v-if="myPrescibeInfo.status == 'M'" @click="fn_save">수정</button>
                <button class="btn btn_md btn_brown" v-else @click="fn_save">등록</button>
            </div> 
          </div>
        </div>
      </article>
    </section>
    <alert-modal 
          :id="'alert'"
          :text="showAlertMsg" 
          :btnRight="'확인'" 
          :oneBtn="false"
          :isShow="showAlert"
          :className="'btn_brown'"
          :closeEventValue="true"
          @closeEvent="oncCloseEvent"
          v-on:update:showSetting="fn_showSet"
      />
    <SearchModal 
        :title="'약재 검색'" 
        :searchName="'약재명'"
        :oneBtn="true"
        :btnLeft="'적용'" 
        :btnRight="'닫기'"
        @callback="fn_callback"
      />
  </div>
</template>

<script>

import axios from 'axios'
import SearchModal from "@/modal/admin/medicineSearch.vue"
import commonUtil from "@/mixin/commonUtil";
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";

export default {
  components: {
    SearchModal,
    AlertModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {
      my_prescribe_seq : '',
      clinic_doctor_id : '',
      myPrescibeInfo : {
        my_prescribe_seq : '',
        clinic_doctor_id : '',
        prescribe_nm : '',
        prescribe_source : '',
        prescribe_category : '',
        prescribe_note : '',
        status : ''
      },
      medicineList : [], 
      prescrbeCategoryList : []    
    };
  },
  async created(){
    this.myPrescibeInfo.my_prescribe_seq = this.$store.getters['detailSearchInfo/getSearchId'];
    this.myPrescibeInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
    this.myPrescibeInfo.status = this.$store.getters['detailSearchInfo/getStatus'];

    this.prescrbeCategoryList = await this.getCode('GC00000015'); 
  },
  mounted(){
    if(this.myPrescibeInfo.status == 'M'){
      this.fn_search();
    }
  },
  methods: {
    fn_search(){

          //환자seq 정보 셋팅
          // this.myPrescibeInfo.my_prescribe_seq = this.my_prescribe_seq;
          // this.myPrescibeInfo.clinic_doctor_id = this.clinic_doctor_id;

          //환자정보 상세조회
          axios
              .post("/api/user/myPrescribe/getMyPrescribeDetail", this.myPrescibeInfo)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  Object.assign(this.myPrescibeInfo, res.data.myPrescribeInfo);

                  this.medicineList = res.data.myPrescribeMedicineList;
              })
              .catch((err) => console.log(err));
              
      },
      fn_move_list_page(){
          this.$store.dispatch('detailSearchInfo/setSearchId', '');
          this.$store.dispatch('detailSearchInfo/setStatus', '');  
          this.$router.push("/mypage/myPrescribeList");
      },
      fn_save(){
        let param = new Object();
        param.myPrescibeInfo = this.myPrescibeInfo;
        param.medicineList = this.medicineList;

        console.log("@@@@ param : %o",param);

        axios.post("/api/user/myPrescribe/regMyPrescibe", param)
          .then((res) => {
                console.log("@@@@ res : %o",res);

                let msg = "저장되었습니다.";
                this.fn_open_alert_close(msg);
                
            })
            .catch((err) => console.log(err));
      },
      fn_callback (medObject){
        medObject.medicine_use_qnty = 0;
        this.medicineList.push(medObject);            
		  },
      fn_medList_delete(idx){
        this.medicineList.splice(idx, 1);
      },
      oncCloseEvent(){
          this.fn_move_list_page();
      }
  },
};
</script>
